module.exports = __webpack_public_path__ + "img/identity-t.8a33a261.png";